// extracted by mini-css-extract-plugin
export var actions = "_la-g";
export var benefitCard = "_la-b";
export var benefitIcon = "_la-d";
export var benefitLabel = "_la-f";
export var benefits = "_la-a";
export var benefitsSection = "_la-8";
export var bodyText = "_la-7";
export var closeButton = "_la-2";
export var content = "_la-3";
export var eyebrow = "_la-4";
export var heading = "_la-5";
export var image = "_la-i";
export var imagePanel = "_la-h";
export var modal = "_la-0";
export var offerCard = "_la-c";
export var offerIcon = "_la-e";
export var sectionLabel = "_la-9";
export var shell = "_la-1";
export var title = "_la-6";